import {
  renderTranslationString,
  TFunctionType
} from 'shared/entities/localization';
import { IPortalPort } from 'shared/entities/portal';
import { IPluginsStore } from 'shared/entities/store/pluginsStore';
import { IRootStore } from 'shared/entities/store/rootStore';
import ExtraInfo from 'shared/models/blocks/PortalExtraInfo';

import { normalizeBase } from '../baseNormalizers';
import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../common';

import { InputPortalInNormalizer } from './client';

export const createInputPortalInActualNameBase = (
  sources: Omit<IPortalPort, 'portal'>[],
  t: TFunctionType
): string => {
  const text = (t: TFunctionType) =>
    t('blockStaticConfigMap.portalIn.text', { ns: 'smartGraphBlocks' });

  const defaultText = (t: TFunctionType) =>
    t('blockStaticConfigMap.portalIn.defaultText', { ns: 'smartGraphBlocks' });

  const block = (t: TFunctionType) =>
    t('blockStaticConfigMap.portalIn.block', { ns: 'smartGraphBlocks' });

  const scenarioNames = sources.map((item) => {
    return `${item.scenario.name} ${
      item.block
        ? `(${block(t)} ${renderTranslationString(item.block?.actualName, t)})`
        : ''
    }`;
  });
  return scenarioNames.length
    ? ` ${text(t)} ${scenarioNames.join(', ')}`
    : defaultText(t);
};

export const createInputPortalInActualName: ActualNameCreator<
  null,
  ExtraInfo
> = ({ extraInfo, t }) => {
  return createInputPortalInActualNameBase(extraInfo.sources, t);
};

export const normalizeInputPortalIn: InputPortalInNormalizer = (
  raw,
  stores: { rootStore: IRootStore; pluginsStore: IPluginsStore }
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: raw.extra_info
          ? createInputPortalInActualNameBase(
              raw.extra_info.sources.map((item) => {
                return {
                  block: item.block ? normalizeBase(item.block, stores) : null,
                  scenario: {
                    id: item.scenario._id,
                    name: item.scenario.name
                  }
                };
              }),
              t
            )
          : '',
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
